<template>
  <router-link
               class="flex border p-1 items-start hover:shadow rounded-card"
               :to="{ name: 'subscription', params: { id: subscription.id }}">
    <CoverImage class="w-20 lg:w-16" :src="subscription.coverImageUrl" :alt="subscription.displayName+' '+t(subscription.typeKey)+' cover'" />
    <div class="ml-2 text-sm">
      <p class="font-semibold leading-none">{{ subscription.displayName }} <span
        class="text-muted font-normal">({{ subscription.orderNumber }})</span></p>
      <p>Status: <OrderStatusLabel :subscription="subscription"/></p>
      <p class="text-xs mt-2">{{$t('business-partner.address-used-as')}}</p>
      <div class="flex flex-wrap gap-1 mt-1" v-if="roles">
        <BusinessPartnerRoleBadge v-for="role in roles" :role="role" />
      </div>
    </div>
  </router-link>
</template>

<script lang="ts" setup>
import { PropType } from 'vue'
import CoverImage from "@/components/CoverImage.vue";
import BusinessPartnerRoleBadge from "@/components/BusinessPartnerRoleBadge.vue";
import { BusinessPartnerRole } from "@/models/businessPartner";
import { Subscription } from "@/models/subscription";
import OrderStatusLabel from "@/components/OrderStatusLabel.vue";
import { useI18n } from "vue-i18n";

defineProps( {
  subscription: {
    type: Subscription,
    required: true
  },
  roles: {
    type: Array as PropType<BusinessPartnerRole[]>,
    default: undefined
  }
})

const {t} = useI18n()
</script>
